import Vue from "vue";

Vue.component("trade-concerns-hs-products-chart", {
	props: ["domainIds", "memberType", "countryId"],
	data() {
		return {
			chartLoading: false,
			chartDataLabel: {},
			chartExporting: {},
			chartData: [],
			chartHasData: false,
		};
	},
	computed: {
		language() {
			return window.languageEnumToString;
		},
	},
	methods: {
		renderHSProductsChart: function (hsCodes) {
			const self = this;
			self.chartLoading = true;

			const params = {
				language: this.language,
				searchParameterMemberCode: this.countryId,
				searchParameterDomainIds: this.domainIds,
				memberProfileType: this.memberType
			}

			if (hsCodes && hsCodes.length > 0) {
				params.searchParameterHSCodes = hsCodes;
			}

			this.$services.tradeConcerns.getHSCodes(params)
				.then((data) => {
					self.chartData = data;
					self.chartDataLabel = {
						align: 'left',
						style: {
							textOutline: 0,
							fontSize: '12px',
						},
						allowOverlap: true,
						color: 'white',
						verticalAlign: 'bottom'
					};
					if (hsCodes && hsCodes.length > 0) {
						self.chartExporting = {
							buttons: {
								contextButton: {
									menuItems: ['downloadPNG'],
								},
								customButton: {
									text: 'Back to Main Chart',
									onclick: function () {
										self.renderHSProductsChart();
									}
								}
							}
						};
					} else {
						self.chartExporting = {
							buttons: {
								contextButton: {
									menuItems: ['downloadPNG'],
								}
							}
						};
					}

					self.chartHasData = data.length > 0;
					self.chartData.map(function (value) {
						value.events = {
							click: function () {
								self.renderHSProductsChart([`${value.dataId}`]);
							}
						};
					});
					self.chartLoading = false;
				});
		},
	},
	mounted() {
		this.renderHSProductsChart();
	},
	watch: {
		domainIds: function () {
			this.renderHSProductsChart();
		}
	},
	template: `
		<chart-tree-map :loading="chartLoading" :chart-data="chartData" :chart-exporting="chartExporting" :chart-name="'HS Chapters'" :chart-data-label="chartDataLabel"></chart-tree-map>
	`,
});